import React from 'react';
import {connect} from 'react-redux';

import {Link} from '../util/Routing';

const ParticipantLink = ({participant}) => (
    <Link route="participant_profile" params={{externalId: participant.externalId}}>
        {participant.name} {participant.mark
            ? `(${participant.mark})`
            : null
        }
    </Link>
);

export default connect(
    (state, props) => ({
        participant: state.getIn(['participants', props.participant])
    })
)(ParticipantLink);
